const KEY = {
    NOTIFICATION: "notification",
    CUBEX: "cubex"
};

export default {
    KEY
};
